<div>iRebal will consider this security to be in the following category (optional):
    <!--    <fa-icon [icon]="faInfoCircle"></fa-icon>-->
    <span id="assetCategoryToolTipIcon" class="infoIcon" calltoaction
          [calltoactionTemplate]="assetCategoryToolTipTemplateRef"></span>
    <span id="assetCustomCategoryLabel"
          class="assetCustomCategoryLabel">{{customCategoryLabel || 'Category'}}</span>
    <span id="assetCustomCategoryDropdown">
        <irb-dropdown-filter
            #customCategoryDropdown
            [(value)]="selectedCustomCategory"
            (search)="getItemsForCustomCategoryDropdown($event)"
            (selection)="onCategoryChanged($event)"
            [addNewItem]="addNewCategoryItem"
            (openNewItemFlow)="openNewItemCategoryFlow($event)"
            size="30">
        </irb-dropdown-filter>
    </span>
    
</div>
<ng-template #assetCategoryToolTipTemplateRef>
    <div class="block">You can create your own categories for securities – by asset class, industry, or however you prefer to identify
        and organize your security types. When Morningstar mapping for ETFs and mutual funds is enabled in the global
        settings, items marked with a * are the matching Morningstar category for that ETF or mutual fund.
    </div>
    <div>Schwab and Morningstar are not affiliated.</div>
</ng-template>
